import {
  useFilterStore,
  useMapStore,
  usePolygonStore
} from '../../../../state-library/src'
import { getPolygonTileSets } from '../../../../apis-library/src'
import { useEffect, useState } from 'react'
import { EHeatMapCategory, EPropertyType } from '../../../../types-library/src'

interface Props {
  children?: React.ReactNode
}

const PolygonsProvider = ({ children }: Props): JSX.Element => {
  const { map } = useMapStore()

  const { propertyType } = useFilterStore()

  const { setPolygonTiles, setHeatMapCategory } = usePolygonStore()

  const [isMounted, setIsMounted] = useState(false)

  /**
   * This function is used to load the tilesets in store.
   * @returns {Promise<void void > }
   */
  const loadTileset = async (): Promise<void> => {
    const { isSuccess, data: tilesets } = await getPolygonTileSets()
    if (!isSuccess || !tilesets?.length) {
      return
    }

    setPolygonTiles(tilesets)
  }

  useEffect(() => {
    if (isMounted) {
      loadTileset()
    }
  }, [isMounted])

  useEffect(() => {
    map?.on('load', () => {
      if (map.isStyleLoaded() && !isMounted) {
        setIsMounted(true)
      }
    })
  })

  useEffect(() => {
    if (propertyType) {
      let category: EHeatMapCategory | undefined

      switch (propertyType) {
        case EPropertyType.SALE:
          category = EHeatMapCategory.PRICE
          break
        case EPropertyType.RENT:
          category = EHeatMapCategory.RENT
          break
        default:
          category = undefined
          break
      }

      if (category !== undefined) {
        setHeatMapCategory(category)
      }
    }
  }, [propertyType])

  return <>{children}</>
}

export default PolygonsProvider
